import React from 'react';
import { useForm, Controller } from 'react-hook-form';
import styled from 'styled-components';

import { TextInput, Button } from 'playup-web-core';

import formatCurrency from '../../../utils/formatCurrency';
import { DepositLimit } from './USDepositModal';
import USAddAmountButton from './USAddAmountButton';
import SecureTransaction from '../USFooter/SecureTransaction';
import QuestionsAndHelp from '../USFooter/QuestionsAndHelp';

//TODO: Add $ prefix to input
//TODO: Add two decimal points limits to input
//TODO: Self limit not enforced, not sure if US has such thing
const USDepositAmount = ({ loading, defaultAmount, activeDepositLimit, onDepositClick, setDepositAmount }: Props) => {
	const [depositAmountError, setDepositAmountError] = React.useState<string>();

	const { register, watch, setValue, control } = useForm<FormData>({
		defaultValues: {
			amount: defaultAmount || 1,
		},
	});
	const inputDepositAmount = watch('amount');

	React.useEffect(() => {
		setDepositAmount(inputDepositAmount * 100);
		if (inputDepositAmount < activeDepositLimit.min / 100)
			setDepositAmountError(`Minimum deposit of: ${formatCurrency(activeDepositLimit.min)}`);
		else if (inputDepositAmount > activeDepositLimit.max / 100)
			setDepositAmountError(`Maximum deposit of: ${formatCurrency(activeDepositLimit.max)}`);
		else setDepositAmountError(undefined);
	}, [activeDepositLimit, inputDepositAmount, setDepositAmount]);

	const onAddAmount = (addedAmount: number) => {
		setDepositAmount(inputDepositAmount + addedAmount);
		// inputDepositAmount will become string once we modify it in input
		setValue('amount', parseInt(inputDepositAmount + '') + addedAmount);
	};
	return (
		<>
			<Controller
				name="amount"
				control={control}
				rules={{ required: true }}
				render={({ field: { value, onChange } }) => {
					return (
						<TextInput
							kind="white"
							label={<TextLabel>Deposit Amount</TextLabel>}
							value={value}
							type="number"
							autoFocus
							placeholder={`Minimum ${formatCurrency(activeDepositLimit.min)}`}
							{...register('amount', {
								valueAsNumber: true,
							})}
							error={depositAmountError}
							onChange={onChange}
						/>
					);
				}}
			/>
			<AddAmountButtonsContainer>
				<USAddAmountButton additionalAmount={20} onClick={onAddAmount} />
				<USAddAmountButton additionalAmount={50} onClick={onAddAmount} />
				<USAddAmountButton additionalAmount={100} onClick={onAddAmount} />
				<USAddAmountButton additionalAmount={250} onClick={onAddAmount} />
				<USAddAmountButton additionalAmount={500} onClick={onAddAmount} />
			</AddAmountButtonsContainer>
			<StyledButton kind="playup" type="submit" height={50} isLoading={loading} onClick={onDepositClick}>
				Next
			</StyledButton>
			<SecureTransaction />
			<QuestionsAndHelp />
		</>
	);
};

export default USDepositAmount;

interface Props {
	loading: boolean;
	defaultAmount?: number;
	activeDepositLimit: DepositLimit;
	onDepositClick: () => void;
	setDepositAmount: (depositAmount: number) => void;
}

interface FormData {
	amount: number;
}

const StyledButton = styled(Button)`
	margin: 20px 0;
`;

const TextLabel = styled.p`
	color: #000;
	font-weight: 600;
	margin-bottom: 15px;
`;

const AddAmountButtonsContainer = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	margin-top: 15px;
	margin-bottom: 25px;
`;
